<div class="post-comment">
  <div class="user-info">
    <img class="user-info-avatar" [src]="userInfo().avatar_url || defaultAvatar" [alt]="userInfo().username" />

    @if (userInfo().username) {
      <div class="user-info-username">{{ userInfo().username }}</div>
    }
  </div>

  @if (commentText()) {
    <div class="comment-text">{{ commentText() }}</div>
  }

  <a class="view-all-button" [href]="postUrl()">View all</a>
</div>
